import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NgxSpinnerService } from "ngx-spinner";
import { VeiculoSensor } from "src/app/models/VeiculoSensor.model";
import { VwSensor } from "src/app/models/VwSensor.model";
import { EventEmitterSensorService } from "src/app/services/event-emitter-sensor.service";
import { ApiBaseService } from "src/app/services/migrate/api.base.service";
import {
  STORAGE_KEY_CURRENT_USER,
  STORAGE_KEY_ID_PERFIL,
} from "src/app/storageCore/constStorageKeys";
import storageX from "src/app/storageCore/storageX";
import Swal from "sweetalert2";
import { appendSensorToCombo, findVeiculoSensorByPosicaoId, findIncompleteSensorRows, alertIncompleteTpmsRows } from "src/app/utils/veiculo-sensor.util";

@Component({
  selector: "app-axle-nine-dual",
  templateUrl: "./axle-nine-dual.component.html",
  styleUrls: ["./axle-nine-dual.component.scss"],
})
export class AxleNineDualComponent implements OnInit {
  @Input() veiculoSensores: any;
  @Input() sensoresDisponiveis: any;
  @Input() veiculoId: number;

  @Output() atualizarSensores = new EventEmitter<void>();

  public sensorNineIntLeftSelect: any = [];
  public sensorNineIntRightSelect: any = [];

  public sensorNineExtLeftSelect: any = [];
  public sensorNineExtRightSelect: any = [];

  public sensorNineIntRightCombo: any = [];
  public sensorNineIntLeftCombo: any = [];

  public sensorNineExtRightCombo: any = [];
  public sensorNineExtLeftCombo: any = [];

  public axisNineDoubleLeftIntForm: FormGroup;
  public axisNineDoubleLeftExtForm: FormGroup;
  public axisNineDoubleRightIntForm: FormGroup;
  public axisNineDoubleRightExtForm: FormGroup;

  constructor(
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    private serviceApiBase: ApiBaseService,
    private componentResetService: EventEmitterSensorService
  ) {}

  ngOnInit(): void {
    this.componentResetService.reiniciarComponentes$.subscribe(async (a) => {
      this.sensoresDisponiveis = null;
      this.veiculoSensores = null;
      this.sensorNineIntRightCombo = [];
      this.sensorNineIntLeftCombo = [];
      this.sensorNineExtRightCombo = [];
      this.sensorNineExtLeftCombo = [];

      const perfil = storageX.whereKeyIs(STORAGE_KEY_ID_PERFIL).get();

      const eixo = await this.serviceApiBase.get<any>({
        url: new VeiculoSensor()["nomeConsultaApiBase"] + this.veiculoId,
      });

      this.veiculoSensores = eixo["content"] ?? [];

      const sensor = await this.serviceApiBase.get<any>({
        url:
          new VwSensor()["nomeConsultaApiBaseSensor"] +
          this.veiculoId +
          "/perfil/" +
          perfil,
      });

      this.sensoresDisponiveis = sensor;

      if (this.sensoresDisponiveis.length > 0) {
        this.sensoresDisponiveis.forEach((element) => {
          this.sensorNineIntRightCombo.push(element);
          this.sensorNineIntLeftCombo.push(element);
          this.sensorNineExtRightCombo.push(element);
          this.sensorNineExtLeftCombo.push(element);
        });
      }

      this.loadSensor();
    });
    this.axisNineDoubleLeftIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisNineDoubleLeftExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisNineDoubleRightIntForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    this.axisNineDoubleRightExtForm = this.formBuilder.group(
      {
        id: [""],
        pneu: [null],
        cdPosicaoPneu: [""],
        cdSensor: [""],
        nrPressaoMinima: ["", Validators.required],
        nrPressaoMaxima: ["", Validators.required],
        nrTemperaturaMaxima: ["", Validators.required],
      },

      { updateOn: "blur" }
    );

    if (this.sensoresDisponiveis.length > 0) {
      this.sensoresDisponiveis.forEach((element) => {
        this.sensorNineExtRightCombo.push(element);
        this.sensorNineExtLeftCombo.push(element);
        this.sensorNineIntRightCombo.push(element);
        this.sensorNineIntLeftCombo.push(element);
      });
    }

    this.loadSensor();
  }

  public async loadSensor(): Promise<void> {
    try {
      this.spinner.show();
      this.axisNineDoubleLeftIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 9 ESQ INT"
      );
      this.axisNineDoubleLeftExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 9 ESQ EXT"
      );

      this.axisNineDoubleRightIntForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 9 DIR INT"
      );
      this.axisNineDoubleRightExtForm.controls["cdPosicaoPneu"].setValue(
        "EIXO 9 DIR EXT"
      );

      if (this.veiculoSensores.length > 0) {
        const eixo9DireitoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          56
        );
        const eixo9EsquerdoExt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          58
        );
        const eixo9DireitoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          55
        );
        const eixo9EsquerdoInt = findVeiculoSensorByPosicaoId(
          this.veiculoSensores,
          57
        );

        // EIXO 9 DIREITO EXTERNO
        if (eixo9DireitoExt != null) {
          this.axisNineDoubleRightExtForm.controls["id"].setValue(
            eixo9DireitoExt.id
          );

          if (eixo9DireitoExt.sensor != null) {
            appendSensorToCombo(this.sensorNineExtRightCombo, eixo9DireitoExt.sensor);
            this.sensorNineExtRightSelect = eixo9DireitoExt.sensor.id;
          }

          if (eixo9DireitoExt.pneu != null) {
            this.axisNineDoubleRightExtForm.controls["pneu"].setValue(
              eixo9DireitoExt.pneu.numeroFogo
            );
          }

          this.axisNineDoubleRightExtForm.controls["nrPressaoMinima"].setValue(
            eixo9DireitoExt.nrPressaoMinima
          );

          this.axisNineDoubleRightExtForm.controls["nrPressaoMaxima"].setValue(
            eixo9DireitoExt.nrPressaoMaxima
          );

          this.axisNineDoubleRightExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo9DireitoExt.nrTemperaturaMaxima);
        }

        // EIXO 9 ESQUERDO EXTERNO
        if (eixo9EsquerdoExt != null) {
          this.axisNineDoubleLeftExtForm.controls["id"].setValue(
            eixo9EsquerdoExt.id
          );

          if (eixo9EsquerdoExt.sensor != null) {
            appendSensorToCombo(this.sensorNineExtLeftCombo, eixo9EsquerdoExt.sensor);
            this.sensorNineExtLeftSelect = eixo9EsquerdoExt.sensor.id;
          }

          if (eixo9EsquerdoExt.pneu != null) {
            this.axisNineDoubleLeftExtForm.controls["pneu"].setValue(
              eixo9EsquerdoExt.pneu.numeroFogo
            );
          }

          this.axisNineDoubleLeftExtForm.controls["nrPressaoMinima"].setValue(
            eixo9EsquerdoExt.nrPressaoMinima
          );

          this.axisNineDoubleLeftExtForm.controls["nrPressaoMaxima"].setValue(
            eixo9EsquerdoExt.nrPressaoMaxima
          );

          this.axisNineDoubleLeftExtForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo9EsquerdoExt.nrTemperaturaMaxima);
        }

        // EIXO 9 DIREITO INTERNO
        if (eixo9DireitoInt != null) {
          this.axisNineDoubleRightIntForm.controls["id"].setValue(
            eixo9DireitoInt.id
          );

          if (eixo9DireitoInt.sensor != null) {
            appendSensorToCombo(this.sensorNineIntRightCombo, eixo9DireitoInt.sensor);
            this.sensorNineIntRightSelect = eixo9DireitoInt.sensor.id;
          }

          if (eixo9DireitoInt.pneu != null) {
            this.axisNineDoubleRightIntForm.controls["pneu"].setValue(
              eixo9DireitoInt.pneu.numeroFogo
            );
          }

          this.axisNineDoubleRightIntForm.controls["nrPressaoMinima"].setValue(
            eixo9DireitoInt.nrPressaoMinima
          );

          this.axisNineDoubleRightIntForm.controls["nrPressaoMaxima"].setValue(
            eixo9DireitoInt.nrPressaoMaxima
          );

          this.axisNineDoubleRightIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo9DireitoInt.nrTemperaturaMaxima);
        }

        // EIXO 9 ESQUERDO INTERNO
        if (eixo9EsquerdoInt != null) {
          this.axisNineDoubleLeftIntForm.controls["id"].setValue(
            eixo9EsquerdoInt.id
          );

          if (eixo9EsquerdoInt.sensor != null) {
            appendSensorToCombo(this.sensorNineIntLeftCombo, eixo9EsquerdoInt.sensor);
            this.sensorNineIntLeftSelect = eixo9EsquerdoInt.sensor.id;
          }

          if (eixo9EsquerdoInt.pneu != null) {
            this.axisNineDoubleLeftIntForm.controls["pneu"].setValue(
              eixo9EsquerdoInt.pneu.numeroFogo
            );
          }

          this.axisNineDoubleLeftIntForm.controls["nrPressaoMinima"].setValue(
            eixo9EsquerdoInt.nrPressaoMinima
          );

          this.axisNineDoubleLeftIntForm.controls["nrPressaoMaxima"].setValue(
            eixo9EsquerdoInt.nrPressaoMaxima
          );

          this.axisNineDoubleLeftIntForm.controls[
            "nrTemperaturaMaxima"
          ].setValue(eixo9EsquerdoInt.nrTemperaturaMaxima);
        }
      }

      this.spinner.hide();
    } catch (error) {
      this.spinner.hide();
      console.error("loadVeiculo() error", error);
    }
  }

  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }
  public async submitFormDelete(form: FormGroup): Promise<void> {
    this.spinner.show();
    try {
      const values = form.value;
      var post;

      post = {
        veiculo: {
          id: this.veiculoId,
        },
        nrPressaoMinima: values.nrPressaoMinima,
        nrPressaoMaxima: values.nrPressaoMaxima,
        nrTemperaturaMaxima: values.nrTemperaturaMaxima,
        sensor: {
          id: values.cdSensor,
        },
        pneu: null,
        idUsuario: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
      };

      console.log(post);

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        values.id,
        new VeiculoSensor()["nomeConsultaApiBaseRemove"],
        post
      );

      form.get("cdSensor").setValue("");
      form.get("id").setValue("");

      this.spinner.hide();

      this.handleDelete();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      //this.errorMessage = error.message;
      throw new EvalError(error);
    }
  }

  public async submitFormDeleteAll(): Promise<void> {
    this.spinner.show();
    try {
      var estepeArray: any = [];
      var posicoesPneusList: any = [];

      estepeArray.push(this.axisNineDoubleLeftExtForm.value);
      estepeArray.push(this.axisNineDoubleRightExtForm.value);
      estepeArray.push(this.axisNineDoubleRightIntForm.value);
      estepeArray.push(this.axisNineDoubleLeftIntForm.value);

      if (estepeArray.length > 0) {
        estepeArray.forEach((element) => {
          var posicaoPneuResquest = {
            cdPosicaoPneu: element.cdPosicaoPneu,
          };
          posicoesPneusList.push(posicaoPneuResquest);
        });
      }

      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseRemoveAll"],
        post
      );

      this.axisNineDoubleLeftExtForm.get("cdSensor").setValue("");
      this.axisNineDoubleLeftExtForm.get("id").setValue("");
      this.axisNineDoubleLeftIntForm.get("cdSensor").setValue("");
      this.axisNineDoubleLeftIntForm.get("id").setValue("");
      this.axisNineDoubleRightExtForm.get("cdSensor").setValue("");
      this.axisNineDoubleRightExtForm.get("id").setValue("");
      this.axisNineDoubleRightIntForm.get("cdSensor").setValue("");
      this.axisNineDoubleRightIntForm.get("id").setValue("");

      this.spinner.hide();

      this.handleDeleteAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }

  public async submitFormAddAll(): Promise<void> {
    var estepeArray: any = [];

      estepeArray.push(this.axisNineDoubleLeftExtForm.value);
      estepeArray.push(this.axisNineDoubleLeftIntForm.value);
      estepeArray.push(this.axisNineDoubleRightExtForm.value);
      estepeArray.push(this.axisNineDoubleRightIntForm.value);

    const posicoesIncompletas = findIncompleteSensorRows(estepeArray);
    if (posicoesIncompletas.length > 0) {
      await alertIncompleteTpmsRows(posicoesIncompletas);
      return;
    }

    if (estepeArray.length > 0 && this.verificarDuplicados(estepeArray)) {
      this.handleItensDuplicados();
      return;
    }

    var posicoesPneusList: any = [];

    estepeArray.forEach((element) => {
      if (element.cdSensor != "") {
        var posicaoPneuResquest = {
          cdPosicaoPneu: element.cdPosicaoPneu,
          cdSensor: element.cdSensor,
          pneu: element.pneu,
          nrPressaoMinima: element.nrPressaoMinima,
          nrPressaoMaxima: element.nrPressaoMaxima,
          nrTemperaturaMaxima: element.nrTemperaturaMaxima,
          idPerfil: storageX.whereKeyIs(STORAGE_KEY_CURRENT_USER).get()?.id,
        };
        posicoesPneusList.push(posicaoPneuResquest);
      }
    });

    if (posicoesPneusList.length === 0) {
      return;
    }

    this.spinner.show();
    try {
      var post = {
        veiculoSensores: posicoesPneusList,
      };

      const result = await this.serviceApiBase.put<VeiculoSensor>(
        this.veiculoId,
        new VeiculoSensor()["nomeConsultaApiBaseAddAll"],
        post
      );

      this.spinner.hide();

      this.handleAddAll();

      this.atualizarSensores.emit();
    } catch (error) {
      this.spinner.hide();
      throw new EvalError(error);
    }
  }


  verificarDuplicados(axisOneArray: any[]): boolean {
    const seen = new Set();
    for (const item of axisOneArray) {
      if (seen.has(item.cdSensor)) {
        return true; // Retorna true se encontrar um valor duplicado
      } else {
        seen.add(item.cdSensor);
      }
    }
    return false; // Retorna false se não houver valores duplicados
  }

  public async handleItensDuplicados(): Promise<void> {
    Swal.fire({
      icon: "warning",
      title: "Sensores selecionados estão com duplicidade, por favor corrigir!",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleAddAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do DIRECIONAL 1 vinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDeleteAll(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensores do DIRECIONAL 1 desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }

  public async handleDelete(): Promise<void> {
    Swal.fire({
      icon: "success",
      title: "Sensor desvinculados com sucesso",
      showCloseButton: false,
      reverseButtons: true,
      showConfirmButton: true,
      confirmButtonText: "OK",
      focusConfirm: false,
    });
  }
}
